import * as React from "react"
/* SVGR has dropped some elements not supported by react-native-svg: style, title */

const AudoryCoinIcon = (props) => (
  <svg
    viewBox="0 0 512 512"
    {...props}
  >
    <defs id="defs835"></defs>
    <path
      style={{
        fill: props.colors.text,
        fillOpacity: 1,
      }}
      id="path839"
      d="M243.21 92.82c26-8.88 64.74-16 115.19-16 99.38 0 153.6 27.67 153.6 41.89 0 14.22-54.22 41.89-153.6 41.89-12.1 0-23.5-.42-34.24-1.17a192.65 192.65 0 0 0-80.95-66.61zM355.8 300.19A190.581 190.581 0 0 1 349 328c3.11.06 6.23.1 9.36.1 61.49 0 119.22-10.68 153.6-28.15V274.8c-38.66 16.09-93.92 25.42-153.6 25.42zm-18.2 55.49a192.09 192.09 0 0 1-16.71 27.1c11.86.78 24.36 1.22 37.5 1.22 74.08 0 128.76-13.49 153.6-27.93v-25.42c-38.66 16.09-93.92 25.42-153.6 25.42-6.993 0-13.923-.13-20.79-.39zm19.2-111.33a193.6 193.6 0 0 1 1.6 24.45c0 1.17-.07 2.33-.09 3.49h.09c61.49 0 119.22-10.68 153.6-28.15v-25.2c-38.66 16.09-93.92 25.42-153.6 25.42zm-16.15-56.18a190.59 190.59 0 0 1 10.44 28.19c2.43 0 4.86.08 7.31.08 61.49 0 119.22-10.68 153.6-28.15v-30.6c-33.91 20.33-94 30.82-153.6 30.82-5.92 0-11.85-.13-17.75-.34zm-7.85 80.63c0 67.302-40.542 127.978-102.72 153.732-62.179 25.754-133.747 11.514-181.337-36.075-47.59-47.59-61.83-119.158-36.075-181.336C38.422 142.942 99.098 102.4 166.4 102.4c91.9 0 166.4 74.5 166.4 166.4z"
      className="cls-1"
    />
    <path
      style={{
        fill: props.colors.cardBackground,
        fillOpacity: 1,
        strokeWidth: 2.52113,
      }}
      d="M166.442 299.515v24.404l-3.152-8.647a117.006 117.006 0 0 0-14.673-25.791 79.491 79.491 0 0 0-19.538-18.304l-5.623 9.026a1.311 1.311 0 0 1-2.319 0l-21.883-39.43c-.404-.732.176-1.664.907-1.438l39.179 11.648a1.69 1.69 0 0 1 .806 2.521l-5.445 8.749a85.39 85.39 0 0 1 19.74 17.95 95.803 95.803 0 0 1 12 19.312z"
      id="path14"
    />
    <path
      style={{
        fill: props.colors.primary,
        strokeWidth: 2.52113,
      }}
      className="cls-1"
      d="M166.467 299.515v24.404l3.151-8.647a117.006 117.006 0 0 1 14.673-25.791 79.491 79.491 0 0 1 19.615-18.304l5.546 8.925a1.311 1.311 0 0 0 2.32 0l21.883-39.43c.404-.731-.176-1.664-.907-1.437l-39.179 11.647a1.69 1.69 0 0 0-.807 2.521l5.446 8.749a85.39 85.39 0 0 0-19.74 18.051 95.803 95.803 0 0 0-12.001 19.312z"
      id="path16"
    />
    <path
      style={{
        fill: props.colors.cardBackground,
        fillOpacity: 1,
        strokeWidth: 2.52113,
      }}
      d="M117.179 197.333a75.634 75.634 0 0 1 97.442 0 93.282 93.282 0 0 1 34.463 7.74c-16.185-28.362-46.187-46.06-83.197-46.06-37.01 0-67.062 17.824-83.071 46.11a92.879 92.879 0 0 1 34.363-7.79z"
      id="path18"
    />
    <path
      style={{
        fill: "none",
        fillOpacity: 1,
        stroke: props.colors.cardBackground,
        strokeWidth: "11.7232px",
        strokeMiterlimit: 10,
        strokeOpacity: 1,
      }}
      className="cls-2"
      d="M250.572 211.174s-37.439-25.21-84.155 0c-46.717-25.034-84.156 0-84.156 0v139.369c48.708-18.253 76.996 0 84.156 0h.176c7.06-.454 35.296-18.279 84.004 0z"
      id="path20"
    />
    <path
      style={{
        fill: props.colors.cardBackground,
        fillOpacity: 1,
        strokeWidth: 2.52113,
      }}
      d="m48.63 236.814 9.655-7.235a.782.782 0 0 1 1.26.756 221.406 221.406 0 0 0-3.58 42.708 224.91 224.91 0 0 0 5.572 49.616.782.782 0 0 1-1.16.857c-3.15-1.765-5.37-3.429-8.47-5.193a1.664 1.664 0 0 1-.807-.984 165.638 165.638 0 0 1-3.025-79.768 1.16 1.16 0 0 1 .554-.757z"
      id="path23"
    />
    <path
      style={{
        fill: props.colors.primary,
        strokeWidth: 2.52113,
      }}
      className="cls-1"
      d="M69.908 328.382c-2.143-1.009-6.555-3.177-8.119-3.983a1.059 1.059 0 0 1-.479-.656 155.478 155.478 0 0 1-3.58-19.11 195.489 195.489 0 0 1-2.672-28.514 204.64 204.64 0 0 1 4.009-46.969.857.857 0 0 1 .403-.605c1.286-.68 2.874-1.412 4.185-2.093 1.311-.68 2.521-1.285 3.706-1.865a215.658 215.658 0 0 0-5.042 51.633 208.75 208.75 0 0 0 8.446 51.204c.327.68-.252 1.235-.857.958z"
      id="path25"
    />
    <path
      style={{
        fill: props.colors.cardBackground,
        fillOpacity: 1,
        strokeWidth: 2.52113,
      }}
      d="M86.068 328.105a2.824 2.824 0 0 1-1.866 2.52 14.749 14.749 0 0 1-5.9 1.463 16.438 16.438 0 0 1-7.562-1.21 3.706 3.706 0 0 1-1.967-2.244 236.835 236.835 0 0 1-6.53-48.053 243.516 243.516 0 0 1 4.437-55.465v-.479a2.521 2.521 0 0 1 .606-.832 11.219 11.219 0 0 1 8.622-2.773 13.16 13.16 0 0 1 8.572 3.378 1.361 1.361 0 0 1 .403 1.06c-1.11 16.034-2.521 33.077-2.698 51.582.101 17.748 3 35.32 3.883 51.053z"
      id="path27"
    />
    <path
      style={{
        fill: props.colors.cardBackground,
        fillOpacity: 1,
        strokeWidth: 2.52113,
      }}
      d="m283.624 236.814-9.656-7.235a.782.782 0 0 0-1.26.756 219.339 219.339 0 0 1 3.504 42.708 223.398 223.398 0 0 1-5.572 49.616.782.782 0 0 0 1.16.857c3.177-1.765 5.395-3.429 8.47-5.193a1.563 1.563 0 0 0 .808-.984 164.302 164.302 0 0 0 6.504-44.7 167.302 167.302 0 0 0-3.454-34.993 1.311 1.311 0 0 0-.504-.832z"
      id="path29"
    />
    <path
      style={{
        fill: props.colors.primary,
        strokeWidth: 2.52113,
      }}
      className="cls-1"
      d="M262.346 328.382c2.143-1.009 6.58-3.177 8.118-3.983a1.084 1.084 0 0 0 .504-.656 151.268 151.268 0 0 0 3.555-19.11 197.96 197.96 0 0 0 2.697-28.514 207.565 207.565 0 0 0-4.008-46.969.882.882 0 0 0-.429-.605c-1.286-.68-2.849-1.412-4.16-2.093a128.72 128.72 0 0 0-3.731-1.865 216.817 216.817 0 0 1 5.042 51.633 209.96 209.96 0 0 1-8.446 51.204c-.176.68.253 1.235.858.958z"
      id="path31"
    />
    <path
      style={{
        fill: props.colors.cardBackground,
        fillOpacity: 1,
        strokeWidth: 2.52113,
      }}
      d="M246.336 328.105a2.798 2.798 0 0 0 1.84 2.52 14.9 14.9 0 0 0 5.926 1.463 16.261 16.261 0 0 0 7.563-1.21 3.756 3.756 0 0 0 1.992-2.244 238.625 238.625 0 0 0 6.53-48.053 241.852 241.852 0 0 0-4.463-55.465v-.479a2.219 2.219 0 0 0-.605-.832 11.219 11.219 0 0 0-8.622-2.773 13.21 13.21 0 0 0-8.572 3.378 1.361 1.361 0 0 0-.404 1.06c1.135 16.034 2.521 33.077 2.698 51.582-.126 17.748-3 35.32-3.883 51.053z"
      id="path33"
    />
  </svg>
)

export default AudoryCoinIcon



// WEBPACK FOOTER //
// ./src/img/AudoryCoinIcon.js